// Source-line candidates for a sales invoice, built from an already-loaded
// customer order (ordersApi.fetchOrderDetail). Options carry business labels
// (order number + product + variant); IDs travel as values only. WP11: with
// the ZK's `invoiceCoverage` loaded, each candidate also carries its
// uninvoiced remainder (label + prefill of a linked line).
import type { OrderDto } from '../../dto/order';
import { coverageLineById } from '../../dto/invoiceCoverage';
import type { WorkflowInvoiceSourceLineCandidate } from '../../types/workflowInvoice';
import { asQuantityUnit } from '../../utils/commercialQuantity';
import { sourceQuantitySetFromLine, withCoverageRemainder } from './workflowInvoiceQuantity';

export function buildSalesSourceLineCandidates(order: OrderDto): WorkflowInvoiceSourceLineCandidate[] {
  return (order.products || []).map((item) => withCoverageRemainder({
    sourceOrderLineId: item.id,
    sourceOrderId: order.id,
    orderNumber: order.displayOrderNumber,
    productName: item.name,
    productVariantId: item.productVariantId,
    variantLabel: item.variantName,
    width: item.width ?? item.catalogProductWidth,
    height: item.height ?? item.catalogProductHeight,
    length: item.length ?? item.catalogProductLength,
    thickness: item.thickness ?? item.catalogProductThickness,
    sourceQuantitySet: sourceQuantitySetFromLine(item),
    sourcePricingUnit: item.saleUnit ? asQuantityUnit(item.saleUnit) : null,
  }, coverageLineById(order.invoiceCoverage, item.id)));
}
